import { Button, Flex } from 'antd'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useRolePermission } from 'src/app/shared/hooks/useRolePermission'
import { EPermissions, ESubModules } from 'src/app/shared/models/roleAndPermission.model'
import { AddIcon, ArrowRightIcon, DollarIcon, ReturnIcon } from 'src/assets/icons'
import { EXCEPTION_STATUS } from '../constants'

import './index.scss'

interface Props {
  onClose: () => void
  handlePay: () => void
  handleReturn: () => void
  handleAddRule?: () => void
  handleClickNext: () => void
  handleClickPrevious: () => void
  selectedId: number
  isFetchingException: boolean
  exceptionStatus: string
  isACH: boolean
  isOverdue: boolean
  isPaying: boolean
  isReturning: boolean
  contextFilteredIdList: string[]
  currentExceptionId: string
  navigationContext: 'EXCEPTION' | 'DECISIONED' | null
}

function ButtonGroup(props: Props) {
  const { t } = useTranslation()
  const {
    onClose,
    handlePay,
    handleReturn,
    handleAddRule,
    handleClickNext,
    handleClickPrevious,
    selectedId,
    isFetchingException,
    exceptionStatus,
    isACH,
    isOverdue,
    isPaying,
    isReturning,
    contextFilteredIdList,
    currentExceptionId,
  } = props
  const { userPermissions } = useRolePermission()

  const isProcessing = exceptionStatus?.toLowerCase() === EXCEPTION_STATUS.PROCESSING
  const isButtonDisabled = isFetchingException

  const currentContextIndex = contextFilteredIdList?.findIndex((id: string) => id === currentExceptionId)

  const isPreviousButtonDisabled = currentContextIndex <= 0 || isButtonDisabled

  const isLastInContext = currentContextIndex !== -1 && currentContextIndex === contextFilteredIdList?.length - 1
  const isNextButtonDisabled = isButtonDisabled || (isLastInContext)

  // const isActionButtonDisplayed = useMemo(
  //   () =>
  //     (!isOverdue && userPermissions[ESubModules.EXCEPT_PROCESS]?.includes(EPermissions.DECISION_EXCEPT)) ||
  //     (!isOverdue && userPermissions[ESubModules.EXCEPT_PROCESS]?.includes(EPermissions.DECISION_CHECK_EXCEPT_BF)) ||
  //     (!isOverdue && userPermissions[ESubModules.EXCEPT_PROCESS]?.includes(EPermissions.DECISION_ACH_EXCEPT_RUL_BF)) ||
  //     (isOverdue && userPermissions[ESubModules.EXCEPT_PROCESS]?.includes(EPermissions.EDIT_EXCEPT)),

  //   [isOverdue, userPermissions],
  // )

  const isActionButtonDisplayedforACH = useMemo(
    () =>
      isACH &&
      ((!isOverdue && userPermissions[ESubModules.EXCEPT_PROCESS]?.includes(EPermissions.DECISION_ACH_EXCEPT_RUL_BF)) ||
        (isOverdue && userPermissions[ESubModules.EXCEPT_PROCESS]?.includes(EPermissions.EDIT_ACH_EXCEPT_RUL_AF))),

    [isOverdue, userPermissions, isACH],
  )

  const isActionButtonDisplayedforCheck = useMemo(
    () =>
      !isACH &&
      ((!isOverdue && userPermissions[ESubModules.EXCEPT_PROCESS]?.includes(EPermissions.DECISION_CHECK_EXCEPT_BF)) ||
        (isOverdue && userPermissions[ESubModules.EXCEPT_PROCESS]?.includes(EPermissions.EDIT_CHECK_EXCEPT_AF))),

    [isOverdue, userPermissions, isACH],
  )

  return (
    <Flex className='exceptionDetailButtonContainer' justify='space-between'>
      <Flex gap={16}>
        <Button
          icon={<ArrowRightIcon className={`flip arrowIcon ${isPreviousButtonDisabled ? 'disabled' : ''}`} />}
          className='button'
          onClick={handleClickPrevious}
          disabled={isPreviousButtonDisabled}
        >
          {t('QuickExceptionProcessing:button.previous')}
        </Button>
        <Button className='button' onClick={handleClickNext} disabled={isNextButtonDisabled}>
          {t('QuickExceptionProcessing:button.next')}
          <ArrowRightIcon className={`arrowIcon ${isNextButtonDisabled ? 'disabled' : ''}`} />
        </Button>
      </Flex>
      <Flex gap={16}>
        {/* {!isFetchingException && isActionButtonDisplayed && (
          <>
            {exceptionStatus?.toLowerCase() !== EXCEPTION_STATUS.RETURNED && (
              <Button
                icon={<ReturnIcon />}
                className='button action-button'
                type='primary'
                onClick={handleReturn}
                disabled={isButtonDisabled || isProcessing}
              >
                {t('QuickExceptionProcessing:button.return')}
              </Button>
            )}
            {exceptionStatus?.toLowerCase() !== EXCEPTION_STATUS.PAID && (
              <Button
                icon={<DollarIcon />}
                className='button action-button'
                type='primary'
                onClick={handlePay}
                disabled={isButtonDisabled || isProcessing}
                loading={isPaying}
              >
                {t('QuickExceptionProcessing:button.pay')}
              </Button>
            )}
          </>
        )} */}

        {!isFetchingException && (isActionButtonDisplayedforACH || isActionButtonDisplayedforCheck) && (
          <>
            {exceptionStatus?.toLowerCase() !== EXCEPTION_STATUS.PAID && (
              <Button
                icon={<DollarIcon />}
                className='button action-button'
                type='primary'
                onClick={handlePay}
                disabled={isButtonDisabled || isProcessing || isReturning}
                loading={isPaying}
              >
                {t('QuickExceptionProcessing:button.pay')}
              </Button>
            )}
            {exceptionStatus?.toLowerCase() !== EXCEPTION_STATUS.RETURNED && (
              <Button
                icon={<ReturnIcon />}
                className='button return-button'
                type='primary'
                onClick={handleReturn}
                disabled={isButtonDisabled || isProcessing || isPaying}
                loading={isReturning}
              >
                {t('QuickExceptionProcessing:button.return')}
              </Button>
            )}
            <Button className='button' onClick={onClose} disabled={isButtonDisabled}>
              {t('QuickExceptionProcessing:button.cancel')}
            </Button>
          </>
        )}

        {
          // Only show AddIcon with ACH Exception
          isACH && userPermissions[ESubModules.EXCEPT_PROCESS]?.includes(EPermissions.ADD_ACH_EXCEPT_RUL) ? (
            <Button
              icon={<AddIcon />}
              className='button action-button'
              type='primary'
              onClick={handleAddRule}
              disabled={isButtonDisabled || isProcessing}
            >
              {t('QuickExceptionProcessing:button.addRule')}
            </Button>
          ) : (
            <></>
          )
        }
      </Flex>
    </Flex>
  )
}

export default ButtonGroup
